import axios from 'axios'
import qs from 'qs'
import commonUrl from '../common/js/commonUrl.js'
import {loadUserId} from '../common/js/cache'

export function getLoginCode(phoneCode) {
  const url = `${commonUrl.apihost}index.php/home/login/loginCode`
  const data = {
    phone: phoneCode
  }
  return axios({
    method: 'POST',
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

export function getLogin(phone, code, id) {
  const url = `${commonUrl.apihost}index.php/home/login/loginPhone`
  const data = {
    phone: phone,
    code: code,
    areasId: id,
    userId: loadUserId() ? loadUserId() : ''
  }
  return axios({
    method: 'POST',
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js